<!-- Subscribers Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Subscribers</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end">
        <!-- Search Input -->
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search subscribers..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="onSearch()"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_subscribers_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="min-w-150px">Name</th>
            <th class="min-w-200px">Email</th>
            <th class="min-w-125px">Country</th>
            <th class="min-w-125px">Subscribe Date</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let subscriber of subscribers; trackBy: trackByFn">
            <td class="ps-2">
              <span class="text-dark fw-bold fs-6">{{ subscriber.name || '-' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">{{ subscriber.email || '-' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">{{ subscriber.country || '-' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">{{ subscriber.created_at | date:'dd MMM yyyy' }}</span>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="subscribers.length === 0">
            <td colspan="4" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No subscribers found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && subscribers.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>
